import { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      
      {/* Logo for all devices */}
      <div 
        className="homepage-logo"
        style={{
          position: 'relative',
          width: '100%',
          textAlign: 'center',
          marginTop: '56px',
          marginBottom: '12px'
        }}
      >
        <img 
          src="/assets/casino-text.png" 
          alt="Logo" 
          className="logo-image"
          style={{
            maxWidth: '500px',
            width: 'clamp(250px, 70vw, 500px)',
            height: 'auto',
            display: 'block',
            margin: '0 auto'
          }}
        />
      </div>
      
      <GameList />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
      
      <style>{`
        @media (max-width: 768px) {
          .homepage-logo {
            margin-top: 36px !important;
            margin-bottom: 8px !important;
          }
          .logo-image {
            max-width: 88% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HomePage;
